import { Form } from "@southfields-digital/mxmz-react-ui";

import type { LocalProperties } from "src/components/GraphicDetails/utils";
import UpdateGraphicButton from "src/components/UpdateGraphicButton";

import PropertyField from "../PropertyField";

import styles from "./GraphicPropertiesForm.module.scss";
import ResourceBoundField from "./ResourceBoundField";

interface IGraphicPropertiesFormProps {
	selectedGraphic: PlaylistGraphic;
	pendingPropertyUpdates: { preview: boolean; live: boolean };
	onGraphicUpdated: (target: "preview" | "live") => void;
	properties: LocalProperties | null;
	handleChangeGraphicProperties: (properties: LocalProperties) => void;
	handleSelectMedia: (
		properties: ImageProperties,
		handleSelectValue?: (value: string) => void,
	) => void;
}

export default function GraphicPropertiesForm({
	selectedGraphic,
	pendingPropertyUpdates,
	onGraphicUpdated,
	handleSelectMedia,
	properties,
	handleChangeGraphicProperties,
}: IGraphicPropertiesFormProps) {
	const handleChange = (props: WithValue, value: string | number | PropertyValue[]) => {
		handleChangeGraphicProperties({
			...properties,
			[props.id]: { ...props, value },
		});
	};

	if (!properties) return null;

	const filteredProperties = Object.values(properties).filter(
		(props) => props.type !== "matchControl" && props.type !== "clock",
	);

	return (
		<div className={styles.Container}>
			{filteredProperties.length > 0 && (
				<div className={styles.UpdateControls}>
					<UpdateGraphicButton
						selectedGraphic={selectedGraphic}
						target="preview"
						isPropertiesDirty={pendingPropertyUpdates.preview}
						onUpdate={() => onGraphicUpdated("preview")}
					/>
					<UpdateGraphicButton
						selectedGraphic={selectedGraphic}
						target="live"
						isPropertiesDirty={pendingPropertyUpdates.live}
						onUpdate={() => onGraphicUpdated("live")}
					/>
				</div>
			)}
			<div className={styles.ScrollArea}>
				<Form className={styles.Form} onSubmit={() => {}} key={"form"}>
					{filteredProperties.map((props) => {
						const { id, name, type } = props;
						const isRepeater = type === "repeater";
						const className = isRepeater ? styles.RepeaterWrapper : styles.ElementWrapper;

						// Resolved per output at air time, so an editable input would only
						// collect a value the resource overwrites.
						const boundResourceId = props.dataBinding?.resourceId;

						return (
							<div className={className} key={id}>
								<div className={styles.FieldLabelRow}>
									<span className={styles.FieldLabel}>{name}</span>
								</div>
								{boundResourceId ? (
									<ResourceBoundField path={props.dataBinding?.path ?? ""} />
								) : (
									<PropertyField
										field={props}
										onChange={(value) => handleChange(props, value)}
										onSelectMedia={handleSelectMedia}
									/>
								)}
							</div>
						);
					})}
				</Form>
			</div>
		</div>
	);
}
